<p-dialog
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [closeOnEscape]="true"
  [closable]="true"
  [header]="resolvedDialogTitle"
  [style]="dialogStyle"
  [contentStyle]="dialogContentStyle"
  (onHide)="onDialogHide()">
  @if (visible) {
    <div class="rule-modal-content">
    @if (showPrivateOffersDisabledNotice) {
      <div class="state-message state-message-disclosure" role="status">
        Private Offers is OFF for this account. You can stage and save this rule, but it will not affect Offer Sets,
        and private offers and unlock prompts will not display until Private Offers is enabled.
      </div>
    }
    <p class="progress-summary" aria-live="polite">
      @if (isOfferSetRule()) {
        Step {{ activeStep }} of 2
      } @else {
        Rule Details
      }
    </p>

    <div class="sr-announcement" aria-live="polite" aria-atomic="true">
      {{ liveAnnouncement }}
    </div>

    @if (initializationError !== '') {
      <div class="state-message state-message-error" role="alert" tabindex="-1">
        <strong>Rule unavailable.</strong>
        <span>{{ initializationError }}</span>
      </div>
    }


    @if (isOfferSetRule()) {
      <p-stepper [value]="activeStep" [linear]="true" class="rule-stepper">
        <p-step-list>
          <p-step [value]="steps.RuleDetails" [disabled]="true">Rule Details</p-step>
          <p-step [value]="steps.OfferSetup" [disabled]="true">Offer Setup</p-step>
        </p-step-list>
        <p-step-panels>
          <p-step-panel [value]="steps.RuleDetails">
            <ng-template #content>
              <section class="step-panel" aria-labelledby="rule-details-heading">
                <auto-ipop-rule-workflow-rule-details
                  #stepOneHeading
                  tabindex="-1"
                  [accountId]="accountId"
                  [initialRule]="initialRule"
                  [isReadOnly]="isReadOnly"
                  [initialRuleType]="initialRuleType"
                  [agedInventoryEnabled]="agedInventoryEnabled"
                  [rangeOverlapError]="rangeOverlapError"
                  [initialDiscoveryFilters]="initialDiscoveryFilters"
                  [initialSelectedSource]="selectedSource"
                  [isEditMode]="isEditMode()"
                  [preserveDependentFilters]="activeStep === steps.OfferSetup"
                  [preserveSelectedSource]="activeStep === steps.OfferSetup"
                  (ruleDetailsChange)="onRuleDetailsChange($event)"
                  (discoveryFiltersChange)="onDiscoveryFiltersChange($event)"
                  (selectedSourceChange)="onSelectedSourceChange($event)"
                  (readinessChange)="onRuleDetailsReadinessChange($event)"
                  (qualifyingVehicleCountChange)="onQualifyingVehicleCountChange($event)"
                  (sourceInvalidated)="onSourceInvalidated()">
                </auto-ipop-rule-workflow-rule-details>

                @if (detailLoading) {
                  <div class="state-message state-message-loading" role="status" aria-live="polite">
                    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                    <span>Loading selected source details. Please wait.</span>
                  </div>
                }

                @if (detailError !== '') {
                  <div
                    class="state-message state-message-error"
                    role="alert"
                    #detailErrorRegion
                    tabindex="-1">
                    <span>{{ detailError }}</span>
                    <p-button
                      label="Retry"
                      severity="secondary"
                      [disabled]="detailLoading"
                      (onClick)="onRetryDetail()">
                    </p-button>
                  </div>
                }

                @if (stageError !== '') {
                  <div class="state-message state-message-error" role="alert">
                    {{ stageError }}
                  </div>
                }

                @if (!canContinue() && !detailLoading && initializationError === '') {
                  <p class="state-message state-message-disclosure" role="status">
                    {{ continueGuidanceMessage() }}
                  </p>
                }

                <div class="modal-actions">
                  <p-button label="Cancel" severity="secondary" (onClick)="requestClose()"></p-button>
                  <p-button
                    label="Continue"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    [disabled]="!canContinue()"
                    (onClick)="onContinue()">
                  </p-button>
                </div>
              </section>
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="steps.OfferSetup">
            <ng-template #content>
              @if (activeStep === steps.OfferSetup) {
                <section class="step-panel" aria-labelledby="offer-setup-heading">
                  @if (stageError !== '') {
                    <div class="state-message state-message-error" role="alert">
                      {{ stageError }}
                    </div>
                  }

                  @if (currentRuleDetails !== null) {
                    <section class="rule-summary" aria-labelledby="configured-rule-details-heading">
                      <h3 id="configured-rule-details-heading">Rule Details</h3>
                      <div class="rule-summary-grid">
                        <div class="summary-field">
                          <label for="summary-rule-type">Rule Type</label>
                          <input id="summary-rule-type" type="text" value="Offer Set Rule" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-privacy">Rule Privacy</label>
                          <input id="summary-privacy" type="text" [value]="formatPrivacy(currentRuleDetails.privacy)" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-status">Status</label>
                          <input id="summary-status" type="text" [value]="currentRuleDetails.status" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-vehicle-type">Vehicle Type</label>
                          <input id="summary-vehicle-type" type="text" [value]="formatVehicleType(currentRuleDetails.vehicleType)" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-year">Year</label>
                          <input id="summary-year" type="text" [value]="currentRuleDetails.year" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-make">Make</label>
                          <input id="summary-make" type="text" [value]="currentRuleDetails.make" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-model">Model</label>
                          <input id="summary-model" type="text" [value]="currentRuleDetails.model" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-trim">Trim</label>
                          <input id="summary-trim" type="text" [value]="currentRuleDetails.trim" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-minimum-price">Minimum Price</label>
                          <input id="summary-minimum-price" type="text" [value]="currentRuleDetails.minimumPrice" readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-maximum-price">Maximum Price</label>
                          <input
                            id="summary-maximum-price"
                            type="text"
                            [value]="currentRuleDetails.maximumPrice"
                            readonly>
                        </div>
                        <div class="summary-field">
                          <label for="summary-vehicle-limit">Vehicle Limit</label>
                          <input
                            id="summary-vehicle-limit"
                            type="text"
                            [value]="currentRuleDetails.vehicleLimit"
                            readonly>
                        </div>
                      </div>
                      <p class="qualifying-vehicle-count">{{ qualifyingVehicleCount }} total vehicles affected</p>
                    </section>
                  }

                  <auto-ipop-rule-workflow-offer-setup
                    #stepTwoHeading
                    tabindex="-1"
                    [selectedSource]="offerSetupSource"
                    [sourceDetail]="sourceDetail"
                    [isReadOnly]="isReadOnly"
                    [existingGeneratedDraft]="initialGeneratedOfferSetDraft"
                    (generatedOfferSetDraftChange)="onGeneratedDraftChange($event)"
                    (readinessChange)="onOfferSetupReadinessChange($event)"
                    (backRequested)="onBackRequested()"
                    (stageRequested)="onOfferStageRequested($event)">
                  </auto-ipop-rule-workflow-offer-setup>

                  <div class="modal-actions modal-actions-cancel-only">
                    <p-button label="Cancel" severity="secondary" (onClick)="requestClose()"></p-button>
                  </div>
                </section>
              }
            </ng-template>
          </p-step-panel>
        </p-step-panels>
      </p-stepper>
    } @else {
      <section class="step-panel" aria-labelledby="rule-details-heading">
        <auto-ipop-rule-workflow-rule-details
          #stepOneHeading
          tabindex="-1"
          [accountId]="accountId"
          [initialRule]="initialRule"
          [isReadOnly]="isReadOnly"
          [initialRuleType]="initialRuleType"
          [agedInventoryEnabled]="agedInventoryEnabled"
          [rangeOverlapError]="rangeOverlapError"
          [initialDiscoveryFilters]="null"
          [initialSelectedSource]="null"
          [isEditMode]="isEditMode()"
          (ruleDetailsChange)="onRuleDetailsChange($event)"
          (discoveryFiltersChange)="onDiscoveryFiltersChange($event)"
          (selectedSourceChange)="onSelectedSourceChange($event)"
          (readinessChange)="onRuleDetailsReadinessChange($event)"
          (qualifyingVehicleCountChange)="onQualifyingVehicleCountChange($event)"
          (sourceInvalidated)="onSourceInvalidated()">
        </auto-ipop-rule-workflow-rule-details>

        @if (isAgedInventoryRule() && agedInventoryEnabled) {
          <fieldset class="aged-strategy-editor" [disabled]="isReadOnly" aria-label="Aged Inventory Discount Table">
            <auto-ipop-aged-inventory-discount-table
              [initialBuckets]="initialAgeBuckets"
              [maximumPrice]="currentRuleDetails?.maximumPrice ?? null"
              [maxDiscountAmount]="currentRuleDetails?.maxDiscountAmount ?? null"
              [discountBasis]="currentRuleDetails?.discountBasis ?? 'selling_price'"
              (bucketsChange)="onAgeBucketsChange($event)"
              (readinessChange)="onAgeBucketsReadinessChange($event)">
            </auto-ipop-aged-inventory-discount-table>
          </fieldset>
        }

        @if (stageError !== '') {
          <div class="state-message state-message-error" role="alert">
            {{ stageError }}
          </div>
        }

        @if (isAgedInventoryRule()) {
          @if (!agedInventoryEnabled) {
            <p class="state-message state-message-disclosure" role="status">
              Aged Inventory Rules are currently unavailable. This rule cannot be staged.
            </p>
          }
          @if (agedInventoryEnabled && !canStageAgedInventoryRule() && initializationError === '') {
            <p class="state-message state-message-disclosure" role="status">
              Enter a Maximum Price and resolve the rule and bucket errors before staging.
            </p>
          }
        } @else {
          @if (!canStageDollarDiscountRule() && initializationError === '') {
            <p class="state-message state-message-disclosure" role="status">
              {{ dollarDiscountRequiredMessage }}
            </p>
          }
        }

        <div class="modal-actions">
          <p-button label="Cancel" severity="secondary" (onClick)="requestClose()"></p-button>
          @if (isAgedInventoryRule()) {
            <p-button
              label="Stage Rule"
              severity="success"
              [disabled]="!canStageAgedInventoryRule()"
              (onClick)="onAgedInventoryStage()">
            </p-button>
          } @else {
            <p-button
              label="Stage"
              severity="success"
              [disabled]="!canStageDollarDiscountRule()"
              (onClick)="onDollarDiscountStage()">
            </p-button>
          }
        </div>
      </section>
    }
    </div>
  }
</p-dialog>
